import { render, staticRenderFns } from "./AboutUs.html?vue&type=template&id=23043f0e&scoped=true&"
import script from "./AboutUs.ts?vue&type=script&lang=ts&"
export * from "./AboutUs.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/about-us/_about.scss?vue&type=style&index=0&id=23043f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23043f0e",
  null
  
)

export default component.exports